import { connect } from 'react-redux';
import Breadcrumbs from './breadcrumbs';

const mapStateToProps = ({ detailsPage }) => ({
  breadcrumbs: detailsPage.loadedProduct.contentSlotsJson.Breadcrumb
    ? detailsPage.loadedProduct.contentSlotsJson.Breadcrumb.components[0].breadcrumbs
    : [],
});

export default connect(mapStateToProps)(Breadcrumbs);
